// extracted by mini-css-extract-plugin
export var buttonHolder = "product-overview-module--buttonHolder--b9bf9";
export var extended = "product-overview-module--extended--e4596";
export var products = "product-overview-module--products--40c76";
export var viewWidth = "product-overview-module--viewWidth--2f860";